import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const KEY = "kn.consent.v1";

function readConsent() {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(KEY); // "granted" | "denied" | null
}

function loadGa() {
  if (document.getElementById("ga-bootstrap")) return;
  const s = document.createElement("script");
  s.id = "ga-bootstrap";
  s.async = true;
  // Served from same origin — complies with strict CSP (script-src 'self').
  // The server returns either a no-op or the GA loader, depending on GA_MEASUREMENT_ID.
  s.src = "/ga.js";
  document.head.appendChild(s);
}

export function CookieBanner() {
  const [consent, setConsent] = useState<string | null>(readConsent);

  useEffect(() => {
    if (consent === "granted") loadGa();
  }, [consent]);

  if (consent) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="הסכמה לעוגיות"
      className="fixed bottom-0 inset-x-0 bg-card border-t shadow-lg z-50"
    >
      <div className="container py-3 flex flex-col sm:flex-row items-center gap-3 text-sm">
        <p className="flex-1">
          האתר משתמש בעוגיות לצורך אנליטיקה (Google Analytics). אפשר לאשר או לדחות.
          <a href="/privacy" className="text-primary hover:underline mr-2">מדיניות פרטיות</a>
        </p>
        <div className="flex gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={() => {
              localStorage.setItem(KEY, "denied");
              setConsent("denied");
            }}
          >
            דחה
          </Button>
          <Button
            size="sm"
            onClick={() => {
              localStorage.setItem(KEY, "granted");
              setConsent("granted");
            }}
          >
            אשר
          </Button>
        </div>
      </div>
    </div>
  );
}
